import { MenuPpal } from './types/types.system';
import { userModule, test, menuOrders, MenuSearch, menuBill, menuReports, menuTrace, menuDashboard, menuCalendar, menuSettings, alert, menuAnalizaer, ExternalSystem } from './images/icons';

export const navigation: MenuPpal[] = [
  {
    text: 'menuPpal',
    path: '/home',
    icon: menuDashboard,
    items: [],
  },
  {
    text: 'menuDate',
    path: '/adminAgendaCitas',
    icon: menuCalendar,
    permission: 'Prm_Citas',
    items: [],
    module: 'ModuleSchedule',
  },
  {
    text: 'menuPatient',
    path: '/patients',
    icon: userModule,
    permission: 'Prm_Pac',
    items: [],
    module: 'ModulePatients',
  },
  {
    text: 'menuOrders',
    path: '',
    icon: menuOrders,
    permission: 'Prm_Ord_R',
    items: [
      {
        text: 'menuAdminOrders',
        path: '/admin-orders',
        permission: 'Prm_Ord',
      },
      {
        text: 'menuPreOrders',
        path: '/preorders',
        permission: 'Prm_Preordenes',
      },
      {
        text: 'menuBarcodes',
        path: '/barcodes',
        permission: 'Prm_CodBarrras',
        module: 'ModuleBarcode',
      },
      {
        text: 'menuReferrals',
        path: '/referrals',
        permission: 'Prm_Ord_Remisiones_R',
        module: 'ModuleRemisions',
        fechaLanzamiento: '2025-06-20',
        fechaFin: '2025-07-30',
      },
      {
        text: 'menuMassValidation',
        path: '/mass-validation',
        permission: 'Prm_ResValMasivo',
        module: 'ModuleValidationMasive',
        fechaLanzamiento: '2025-06-20',
        fechaFin: '2025-07-30',
      },
    ],
  },
  {
    text: 'menuSamples',
    path: '',
    icon: test,
    module: 'ModuleSamples',
    permission: 'Prm_Ord_Tracking_R',
    items: [
      {
        text: 'menuTracking',
        path: '/tracking',
        permission: 'Prm_Ord_Tracking_R',
        module: 'ModuleTracking',
      },
      {
        text: 'menuSerumLibrary',
        path: '/serum-library',
        permission: 'Prm_Seroteca_R',
        fechaLanzamiento: '2025-06-15', // Ejemplo: submenu nuevo (muy reciente - 4 días)
        fechaFin: '2025-08-01',
      },
    ],
  },
  {
    text: 'menuSearches',
    path: '',
    icon: MenuSearch,
    module: 'ModuleSearches',
    permission: 'Prm_Busqueda',
    items: [
      {
        text: 'menuSearchesOrders',
        path: '/find-results',
        permission: 'Prm_BusquedaOrdenes',
        fechaLanzamiento: '2025-06-10',
        fechaFin: '2025-07-30',
      },
      {
        text: 'menuSearchesPatients',
        path: '/find-patient',
        permission: 'Prm_BusquedaPacientes',
        fechaLanzamiento: '2025-08-14',
        fechaFin: '2025-09-30',
      },
      // {
      //   text: 'menuMassPrinting',
      //   path: '/mass-printing',
      //   permission: 'Prm_Imprimir',
      // },
      // {
      //   text: 'menuMassValidation',
      //   path: '/mass-validation',
      //   permission: 'Prm_ResValidar',
      // },
      // {
      //   text: 'menuTimers',
      //   path: '/timers',
      //   permission: '',
      // },
    ],
  },
  {
    text: 'menuBilling',
    path: '',
    icon: menuBill,
    items: [
      {
        text: 'menuQuotations',
        path: '/quotations',
        permission: 'Prm_Cotizaciones',
      },
      {
        text: 'menuCashier',
        path: '/cashier',
        permission: 'Prm_FactCaja',
      },
    ],
    permission: 'Prm_Fact',
    module: 'ModuleBilling',
  },
  {
    text: 'menuConections',
    path: '/conexiones',
    icon: ExternalSystem,
    permission: 'Prm_External',
    items: [],
  },
  {
    text: 'menuReports',
    path: '',
    icon: menuReports,
    permission: 'Prm_Inf',
    items: [
      // {
      //   text: 'menuDashboards',
      //   path: '/dashboards',
      //   permission: 'Prm_Inf',
      // },
      {
        text: 'menuReportsandstatistics',
        path: '/reports',
        permission: 'Prm_Inf',
      },
      {
        text: 'menuControlBoards',
        path: '/control-boards',
        permission: 'Prm_Inf',
      },
    ],
  },
  {
    text: 'menuAnalizers',
    path: '/analyzers',
    icon: menuAnalizaer,
    items: [],
    permission: 'Prm_Analizador',
    module: 'ModuleAnalyzers',
  },
  {
    text: 'menuTraceability',
    path: '/traceability',
    icon: menuTrace,
    items: [],
    permission: 'Prm_Monitoreo',
  },
  {
    text: 'menuWarnings',
    path: '/warnings',
    icon: alert,
    items: [],
    permission: 'Prm_Alarmas_R',
    module: 'ModuleWarnings',
  },
  {
    text: 'menuConfiguration',
    path: '',
    icon: menuSettings,
    permission: 'Prm_Conf',
    items: [
      {
        text: 'menuConfigurationAgenda',
        path: '/configAgendaCitas',
        permission: 'Prm_Config_Citas',
      },
      // {
      //   text: 'menuConfigurationAlarmas',
      //   path: '/alarmas',
      // },
      {
        text: 'menuConfigurationAnalitos',
        path: '/analitos',
        permission: 'Prm_Conf_Analito',
      },
      {
        text: 'menuConfigurationAnalizadores',
        path: '/analizadores',
      },
      // {
      //   text: 'menuConfigurationCamposDinamicos',
      //   path: '/config-campos-dinamicos',
      // },
      {
        text: 'menuConfigurationConfigGeneral',
        path: '/config-general',
      },
      {
        text: 'menuConfigurationDefiniciones',
        path: '/config-reportes-definiciones',
        permission: 'Prm_Conf_Campos',
      },
      {
        text: 'menuConfigurationEstudios',
        path: '/estudios',
        permission: 'Prm_Conf_Estudio',
      },
      {
        text: 'menuConfigurationFacturacion',
        path: '/config-facturacion',
        permission: 'Prm_Config_Facturacion',
      },
      {
        text: 'menuConfigurationImpresoraCodBarras',
        path: '/configbarcodes',
        permission: 'Prm_Conf_Barcode_Imp',
      },
      {
        text: 'menuConfigurationEstudiosPerfiles',
        path: '/estudios-perfiles',
      },
      // {
      //   text: 'menuConfigurationPermisos',
      //   path: '/config-permisos',
      // },
      {
        text: 'menuConfigurationReportes',
        path: '/config-reportes',
        permission: 'Prm_Conf_Reportes',
      },
      // {
      //   text: 'menuConfigurationReportesInformes',
      //   path: '/config-reportes-informes',
      // },
      // {
      //   text: 'menuConfigurationReportesInformesDisenador',
      //   path: '/config-reportes-disenador',
      // },
      {
        text: 'menuConfigurationTablas',
        path: '/config-tablas',
        permission: 'Prm_ConfTablas',
      },
      {
        text: 'menuConfigWebPagePatients',
        path: '/config-web-page-patients',
        permission: 'Prm_PagWebRes_Config',
      },
      {
        text: 'menuConfigurationUsuarios',
        path: '/config-usuarios',
        permission: 'Prm_Conf_Usuario',
      },
      {
        text: 'menuConfigurationTareasOperativa',
        path: '/tareas-operativas',
        permission: 'Prm_Conf_Manejo',
      },
      {
        text: 'menuConfigurationNotes',
        path: '/config-notas',
        permission: 'Prm_ConfTablas',
      },
      {
        text: 'menuConfigurationEmailTemplates',
        path: '/config-email-templates',
        permission: 'Prm_ConfTablas',
      },
      {
        text: 'menuConfigInformedConsents',
        path: '/config-informed-consents',
        permission: 'Prm_Conf_Consentimientos',
        module: 'ModuleInformedConsents',
      },
      {
        text: 'menuConfigBackups',
        path: '/config-backups',
        permission: 'Prm_BackUp_R',       
      }
    ],
  },
];
